// Brand collections + the upcoming event used by the pop-up / pre-order UI.
// Product membership lives on each product's `collection` field (demoProducts).
import homeImg from "../assets/home.png";
import blocc6 from "../assets/blocc6.png";
import female from "../assets/female.png";

// Endpoint that receives "notify me" / event registrations (same Formspree form
// the cart uses). Replace with a dedicated form id when you have one.
export const NOTIFY_ENDPOINT = "https://formspree.io/f/xeqbbejn";

export const collections = [
  {
    id: "military-coup-deluxe",
    name: "Military Coup Deluxe",
    season: "2024 Collection",
    shopKey: "Military Coup Deluxe",
    tagline: "A spotlight on history and enlightenment.",
    story:
      "Deluxe to the 2024 Military Coup collection — inspired by the General Sani Abacha coup of 1993. A study in power, memory and reinvention, worn forward.",
    heroImage: blocc6,
  },
  {
    id: "the-challengers",
    name: "The Challengers",
    season: "Core Line",
    shopKey: "The Challengers",
    tagline: "For those who move first.",
    story:
      "Everyday armour for the ones who push. Clean lines, hard-wearing fabrics, zero compromise.",
    heroImage: homeImg,
  },
  {
    id: "women-should-be-gods",
    name: "Women Should Be Gods",
    season: "Womenswear",
    shopKey: "Women Should Be Gods",
    tagline: "Dressed like the divine.",
    story:
      "A womenswear capsule built on reverence — sculptural, powerful and unapologetic.",
    heroImage: female,
  },
];

// The registration block shown in the pop-up, homepage banner and
// Collections page. With `date: null` it reads as a community sign-up;
// set a date (e.g. "2026-08-15T18:00:00") when there's a real event and
// the countdown + event framing appear automatically.
export const upcomingEvent = {
  id: "lormami-community",
  title: "Join the LORMAMI Community",
  date: null,
  location: "Lagos, Nigeria",
  blurb:
    "Be the first to hear about new drops, events and exclusive releases. Register with your email and we'll keep you in the loop.",
  image: blocc6,
};
